'use client';

import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface Props {
  text: string | undefined;
  className?: string;
  delay?: number;
}

export default function RandomText({ text, className, delay = 0 }: Props) {
  const [selectedText, setSelectedText] = useState<string>('');

  useEffect(() => {
    if (!text) return;
    
    // Парсим строки, убираем пустые
    const lines = text.split('\n').map(l => l.trim()).filter(Boolean);
    if (lines.length === 0) return;
    
    // Выбираем рандомную
    const randomIndex = Math.floor(Math.random() * lines.length);
    setSelectedText(lines[randomIndex]);
  }, [text]);

  if (!selectedText) {
    // Временная заглушка для серверного рендеринга (первая строка или пусто)
    // чтобы не было прыжка контента, можно вывести первую строку без анимации
    const firstLine = text?.split('\n')[0]?.trim() || '';
    return <span className={className}>{firstLine}</span>;
  }

  return (
    <motion.span
      key={selectedText}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      className={className}
    >
      {selectedText}
    </motion.span>
  );
}
